export const environment = {
  production: true,
  apiUrl: 'https://portalsvc.ascprofiles.com',
  baseRef: 'https://portal.ascprofiles.com'
};
